import {
  SET_FAVOURITE_PERSONS,
} from "./constants";

export const dispatchSetFavouritePersons = (favouritePersons) => ({
  type: SET_FAVOURITE_PERSONS,
  favouritePersons,
});